export const ControlMasks = {
    phone: '(000) 000-0000',
    phoneAlt: '000-000-0000',
    ssn: '000-00-0000',
    shortDateFourDigitYear: 'M0/d0/0000',
    shortDateTwoDigitYear: 'M0/d0/00',
    shortZipCode: '00000',
    longZipCode: '00000-0000',
    nationalProviderNumnber: '0000000000'
};
